const getUserLogged = () => {
    return JSON.parse(localStorage.getItem('app-user'));
};

const removeUserLoggedData = () => {
    localStorage.removeItem('app-user-api-token');
}

const setApiAccessToken = (accessToken) =>{
    localStorage.setItem('app-user-api-token', accessToken);
}

const getApiAccessToken = () =>{
    return localStorage.getItem('app-user-api-token');
}

const userLogged = {
    getUserLogged,
    removeUserLoggedData,
    setApiAccessToken,
    getApiAccessToken
};

export default userLogged;